export const projectTypeConstants = {
    GET_SUCCESS: 'GET_PROJECTTYPE_SUCCESS',

    ADD_SUCCESS: 'ADD_PROJECTTYPE_SUCCESS',
    ADD_FAILURE: 'ADD_PROJECTTYPE_FAILURE',

    DELETE_SUCCESS: 'DELETE_PROJECTTYPE_SUCCESS',
    DELETE_FAILURE: 'DELETE_PROJECTTYPE_FAILURE',

    UPDATE_SUCCESS: 'UPDATE_PROJECTTYPE_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_PROJECTTYPE_FAILURE',

    CLEAR_ERROR: 'CLEAR_PROJECTTYPE_ERROR_CODE'
};
